import * as THREE from "three";

export function createLensflareTextures() {
  const textureFlare0 = createFlareTexture(0);
  const textureFlare3 = createFlareTexture(3);
  return { textureFlare0, textureFlare3 };
}

function createFlareTexture(type) {
  const canvas = document.createElement('canvas');
  canvas.width = 256;
  canvas.height = 256;
  const ctx = canvas.getContext('2d');

  if (type === 0) {
    // Main sun flare - bright center with soft falloff
    const gradient = ctx.createRadialGradient(128, 128, 0, 128, 128, 128);
    gradient.addColorStop(0, 'rgba(255, 255, 255, 1)');
    gradient.addColorStop(0.1, 'rgba(255, 250, 240, 0.9)');
    gradient.addColorStop(0.25, 'rgba(255, 229, 176, 0.6)');
    gradient.addColorStop(0.5, 'rgba(255, 229, 176, 0.2)');
    gradient.addColorStop(1, 'rgba(255, 229, 176, 0)');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 256, 256);
  } else {
    // Secondary flares - softer, more diffuse
    const gradient = ctx.createRadialGradient(128, 128, 0, 128, 128, 128);
    gradient.addColorStop(0, 'rgba(255, 229, 176, 0.6)');
    gradient.addColorStop(0.3, 'rgba(255, 229, 176, 0.3)');
    gradient.addColorStop(0.6, 'rgba(255, 229, 176, 0.1)');
    gradient.addColorStop(1, 'rgba(255, 229, 176, 0)');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 256, 256);
  }

  const texture = new THREE.CanvasTexture(canvas);
  texture.minFilter = THREE.LinearFilter;
  texture.magFilter = THREE.LinearFilter;
  return texture;
}
